import styled from 'styled-components/macro'
import { RiverLogoLoader } from './RiverLogoLoader'

const StyledMediumLoader = styled.div<{ extraStyles: string }>`
  ${({ extraStyles }) => extraStyles}
`

export const MediumLoader = ({ extraStyles = '' }) => (
  <StyledMediumLoader extraStyles={extraStyles}>
    <RiverLogoLoader />
  </StyledMediumLoader>
)
